'use client';

import { useTranslations } from 'next-intl';

const LoginFormHeader = () => {
  const t = useTranslations('LoginPage');

  return (
    <div>
      <h1 className="pb-2 text-2xl font-semibold text-veni-green-900">{t('titleText')}</h1>
      <p className="text-sm text-veni-green-900">{t('portalDescription')}</p>
    </div>
  );
};

export default LoginFormHeader;
